/**
 * @generated SignedSource<<7158c1992892a193c5e9987bcf2665b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PassengerTableRow_orderRoom$data = {
  readonly name: string;
  readonly " $fragmentType": "PassengerTableRow_orderRoom";
};
export type PassengerTableRow_orderRoom$key = {
  readonly " $data"?: PassengerTableRow_orderRoom$data;
  readonly " $fragmentSpreads": FragmentRefs<"PassengerTableRow_orderRoom">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PassengerTableRow_orderRoom",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "OrderRoom",
  "abstractKey": null
};

(node as any).hash = "d5d354520edc82dfc592e18236c56906";

export default node;
